export default "/assets/lobby1.f9e5716c8f3db5e746ce31f9270d6926.png";